"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _api = require("@whitbread-eos/api");
var _ = require("../../../");
var getAccountPayments = function () {
  var _ref = (0, _asyncToGenerator2.default)(function* (token, accountId, page, size, tetheredUserGuid) {
    var nonInvoiceOnly = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    return yield (0, _.executeGraphQLQuery)((0, _api.getAccountPaymentsQuery)(), {
      paymentInfoCriteria: {
        accountId: accountId,
        tetheredUserGuid: tetheredUserGuid,
        nonInvoiceOnly: nonInvoiceOnly,
        page: page,
        size: size
      }
    }, result => result.data.getPaymentInfo, token, true, false);
  });
  return function getAccountPayments(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();
var _default = exports.default = getAccountPayments;